// extracted by mini-css-extract-plugin
export var hero = "news-archive-module--hero--gLoqI";
export var heroContainer = "news-archive-module--heroContainer--RxmOm";
export var heroColumn = "news-archive-module--heroColumn--cJp1u";
export var newsSection = "news-archive-module--newsSection--K+mwO";
export var newsItem = "news-archive-module--newsItem--0pxdD";
export var filterColumn = "news-archive-module--filterColumn--mDLpq";
export var filterItem = "news-archive-module--filterItem--csyUk";